const alarmsSchema = {
  level: {
    type: Number,
    required: true,
  },
  color: {
    type: String,
    required: true,
  },
  machineName: {
    type: String,
    required: true,
  },
  hall: {
    type: String,
    required: true,
  },
  duration: {
    type: Number,
    required: true,
  },
  start: {
    type: Number,
    required: true,
  },
  end: {
    type: Number,
    required: true,
  },
};

export default alarmsSchema;



// WEBPACK FOOTER //
// ./src/schemas/alarms.js